/* eslint-disable react-hooks/exhaustive-deps */
import { useState, memo } from "react";
import { Image, Spinner } from "react-bootstrap";
import { useBetween } from "use-between";

import ItemImage from "../../assets/images/collection/product.png";
import { TrashIcon } from "../icons";
import { useCartApi } from "../../pages/useApi";
import { toast } from "react-toastify";
import { toTwoDecimals } from "../../plugins";
import { useNavigate } from "react-router-dom";

export function customOperation(a, b) {
    if (a % 5 === 0) {
        return 5;
    } else if (a % 2 === 1) {
        const remainder = b % a;
        const half = Math.floor(a / 2);

        if (remainder === half) {
            return remainder + 1;
        }
        if (remainder > half) {
            return half;
        }

    } else {
        return (a / 2);
    }
}

const buildCartMutationPayload = (currentCart, products) => {
    const data = {
        sessionId: currentCart.customerId,
        customerId: currentCart.customerId,
        products
    };
    return currentCart._id
        ? { type: "update", cartId: currentCart._id, data }
        : { type: "add", data };
};

const CartItem = ({ item }) => {
    const [isDeleting, setIsDeleting] = useState(false);
    const { cart, mutateCart, linePricingByProductId } = useBetween(useCartApi);
    const navigate = useNavigate();
    const productId = String(item?.InventoryID?.value ?? "");
    const cartQuantity =
        cart?.products?.find((product) => product.productId === productId)?.quantity ??
        linePricingByProductId?.[productId]?.quantity ??
        0;
    const linePricing = linePricingByProductId?.[productId];
    const lineTotal = linePricing
        ? Number(linePricing.lineTotal || 0)
        : Number((item?.DefaultPrice?.value || 0) * cartQuantity);
    const lineSubtotal = linePricing ? Number(linePricing.lineSubtotal || 0) : lineTotal;
    const hasDiscount = Boolean(linePricing && Number(linePricing.lineDiscount || 0) > 0);

    const addToCart = (item) => {
        mutateCart(productId, (currentCart) => {
            const products = [...(currentCart.products || [])];
            const duplicatedId = products.findIndex(
                (product) => product.productId === productId
            );
            if (duplicatedId < 0) {
                return null;
            }
            const quantityToAdd = item.Casesize.value <= 5
                ? item.Casesize.value
                : customOperation(item.Casesize.value, products[duplicatedId].quantity);

            products[duplicatedId] = {
                ...products[duplicatedId],
                quantity: products[duplicatedId].quantity + quantityToAdd
            };

            return buildCartMutationPayload(currentCart, products);
        }).catch((err) => {
            toast.error(err?.message || "Failed to update cart");
        });
    };

    const removeToCart = (item) => {
        mutateCart(productId, (currentCart) => {
            const products = [...(currentCart.products || [])];
            const duplicatedId = products.findIndex(
                (product) => product.productId === productId
            );
            if (duplicatedId < 0) {
                return null;
            }
            const quantityToRemove = item.Casesize.value <= 5
                ? item.Casesize.value
                : customOperation(item.Casesize.value, products[duplicatedId].quantity);

            let nextProducts;
            if (products[duplicatedId].quantity <= item.Casesize.value) {
                nextProducts = products.filter((_, index) => index !== duplicatedId);
            } else {
                nextProducts = [...products];
                nextProducts[duplicatedId] = {
                    ...nextProducts[duplicatedId],
                    quantity: nextProducts[duplicatedId].quantity - quantityToRemove
                };
            }

            return buildCartMutationPayload(currentCart, nextProducts);
        }).catch((err) => {
            toast.error(err?.message || "Failed to update cart");
        });
    };

    const removeProduct = () => {
        if (isDeleting) {
            return;
        }
        setIsDeleting(true);

        mutateCart(productId, (currentCart) => {
            const products = (currentCart.products || []).filter(
                (product) => product.productId !== productId
            );
            return buildCartMutationPayload(currentCart, products);
        })
            .then(() => {
                setIsDeleting(false);
            })
            .catch((err) => {
                toast.error(err?.message || "Failed to update cart");
                setIsDeleting(false);
            });
    };

    return (
        <div className='cart-item' data-attr={item._id}>
            <div className='cart-product-content'>
                <div className='cart-product-image'>
                    <div className='img-wrapper'>
                        {item
                            .Primaryproductimagefirstdisplayed.value ? (
                            <Image
                                src={
                                    item
                                        .Primaryproductimagefirstdisplayed.value
                                }
                                alt='product'
                            />
                        ) : (
                            <Image src={ItemImage} alt='product' />
                        )}
                    </div>
                </div>
                <div className='cart-item-wrapper'>
                    <h6>
                        <button
                            type='button'
                            className='cart-item-link'
                            onClick={() =>
                                navigate(
                                    `/product/${productId}`
                                )
                            }
                        >
                            {`${item.Brand.value} | ${item.Buyermenuproductname.value}`}
                        </button>
                    </h6>
                    <button
                        type='button'
                        className='cart-item-name cart-item-link'
                        onClick={() =>
                            navigate(
                                `/product/${productId}`
                            )
                        }
                    >
                        {item.StrainDescription.value}
                        {item.Phenotype ? (
                            <span
                                className='green-tg'
                                data-phenotype={
                                    item.Phenotype
                                }
                            >
                                <span>
                                    {item.Phenotype.charAt(0).toUpperCase()}
                                </span>
                            </span>
                        ) : null}
                    </button>
                    <div className='product-price-info d-inline-flex'>
                        {/* <label className='price-per-unit'>{`$${toTwoDecimals(
                        item.DefaultPrice.value
                    )} / unit`}</label> */}
                        {linePricing?.promotionType === "DISCOUNT" && linePricing?.discountedUnitPrice !== undefined ? (
                            <>
                                <label className='price-per-unit origin'>{`$${toTwoDecimals(
                                    linePricing.originalUnitPrice
                                )}`}</label>
                                <label className='price-per-unit'>{`$${toTwoDecimals(
                                    linePricing.discountedUnitPrice
                                )}`}</label>
                            </>
                        ) : (
                            <label className='price-per-unit'>{`$${toTwoDecimals(
                                item.DefaultPrice?.value
                            )}`}</label>
                        )}
                        <label className='offered-price-info'>{`$${toTwoDecimals(
                            item.DefaultPrice?.value *
                            item.Casesize.value
                        )} / case (${item.Casesize.value
                            } units)`}</label>
                    </div>
                    {linePricing?.promotionType === "DISCOUNT" ? (
                        <div className='mt-1'>
                            <small className='text-success'>
                                {linePricing.discountType === "PERCENTAGE"
                                    ? `Discount applied: ${linePricing.discountValue}% off`
                                    : `Discount applied: $${toTwoDecimals(linePricing.discountValue || 0)} off`}
                            </small>
                        </div>
                    ) : null}
                    {linePricing?.promotionType === "BOGO" && linePricing?.discountedQuantity > 0 ? (
                        <div className='mt-1'>
                            {linePricing.discountedUnitPrice === 0 ? (
                                <small className='text-success'>
                                    {`BOGO applied: ${linePricing.freeQuantity} free (auto-applied)`}
                                </small>
                            ) : linePricing.discountedUnitPrice ? (
                                <small className='text-success'>
                                    {`BOGO applied: ${linePricing.discountedQuantity} discounted @ $${toTwoDecimals(
                                        linePricing.discountedUnitPrice
                                    )} (auto-applied)`}
                                </small>
                            ) : (
                                <small className='text-success'>
                                    {`BOGO applied: ${linePricing.discountedQuantity} discounted (auto-applied)`}
                                </small>
                            )}
                        </div>
                    ) : null}
                    <div className='qty-container d-inline-flex align-items-center'>
                        <div className='qty-wrapper'>
                            <span
                                onClick={() => {
                                    removeToCart(item);
                                }}
                                className='cursor-pointer qty'
                            >
                                -
                            </span>
                            <span
                                className='qty-value'>{cartQuantity}</span>
                            <span
                                onClick={() => {
                                    addToCart(item);
                                }}
                                className='cursor-pointer qty'
                            >
                                +
                            </span>
                        </div>
                        <div className='d-flex ml-4 price-container'>
                            <p className=''>
                                {hasDiscount ? (
                                    <span className='origin me-2'>{`$${toTwoDecimals(lineSubtotal)}`}</span>
                                ) : null}
                                {`$${toTwoDecimals(lineTotal)}`}
                            </p>
                        </div>
                    </div>
                    {linePricing?.promotionType === "BOGO" && linePricing?.discountedQuantity > 0 ? (
                        <div className='promotion-breakdown'>
                            <small className='text-muted'>
                                {`Paid: ${linePricing.chargedQuantity} • `}
                                {linePricing.discountedUnitPrice === 0
                                    ? `Free: ${linePricing.freeQuantity}`
                                    : `Discounted: ${linePricing.discountedQuantity}`}
                            </small>
                        </div>
                    ) : null}
                </div>
            </div>
            <div className='cart-image-action'>
                <span
                    className={`btn-remove ${isDeleting ? "is-deleting" : "cursor-pointer"}`}
                    onClick={() => {
                        if (!isDeleting) {
                            removeProduct(item);
                        }
                    }}
                >
                    {isDeleting ? (
                        <Spinner animation='border' size='sm' />
                    ) : (
                        <TrashIcon width='24' height='24' />
                    )}
                </span>
            </div>
        </div>
    );
};

export default memo(CartItem);
